<template>
  <div class="container">
    <div class="header">
      <div class="headerContent">
        <div class="breadcrumbs">
          <div class="text">Private Pilot 2025</div>
          <div>|</div>
          <div class="text">Pilot Qualifications</div>
          <div>|</div>
          <b class="pageTitle">{{ assignment.name }}</b>
        </div>
      </div>
      <div class="backButton" @click="navigateBack">
        <img class="backIcon" alt="" src="/static/img/LeftChevron.svg" />
      </div>
    </div>
    <div class="assignment">
      <div class="quizOverviewContainer">
        <div class="quizOverview">
          <div>
            <b class="quizTitle">{{ assignment.name }}</b>
            <div class="quizObjective">
              {{ assignment.description }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="questionContainer"
        v-for="(question, index) in assignment.questions"
        :key="question.id"
      >
        <b class="questionNumber">Question {{ index + 1 }}</b>
        <div class="question">
          {{ question.question }}
        </div>
        <div
          class="frameParent2"
          v-if="getQuestionType(question, 'Multiple Choice', index)"
        >
          <div
            v-for="(choice, answerIndex) in question.questionChoices"
            :key="answerIndex"
            class="answerContainer"
          >
            <!-- <span v-if="isAnswered">testing</span> -->
            <label :for="`answer-${answerIndex}`" class="text">{{
              choice.description
            }}</label>
            <input
              type="radio"
              :id="`answer-${answerIndex}`"
              v-model="form[question.id]"
              :value="choice.id"
            />
          </div>
        </div>
        <div
          class="frameParent2"
          v-else-if="getQuestionType(question, 'Short Answer', index)"
        >
          <div class="answerWrapper">
            <div class="answer" v-if="gradeView"></div>
            <div v-else>
              <textarea
                class="textArea"
                placeholder="Type your answer here..."
                v-model="form[question.id]"
              ></textarea>
            </div>
          </div>
        </div>
        <div
          class="frameParent2"
          v-else-if="getQuestionType(question, 'Select All That Apply', index)"
        >
          <div
            v-for="(choice, answerIndex) in question.questionChoices"
            :key="answerIndex"
            class="answerContainer"
          >
            <input
              type="checkbox"
              :id="`select-all-${question.id}-${answerIndex}`"
              @change="(e) => handleSelect(e, question.id, choice.id)"
            />
            <label
              :for="`select-all-${question.id}-${answerIndex}`"
              class="text"
              >{{ choice.description }}</label
            >
          </div>
        </div>
        <div
          class="matchingContainer"
          v-else-if="getQuestionType(question, 'Matching', index)"
        >
          <div
            class="matchingChoiceContainer"
            v-for="choice of question.questionChoices"
            v-bind:key="choice.id"
          >
            <div class="column1Matching">
              {{ choice.description }}
            </div>
            <div class="column2Matching">
              <hilo-select
                :options="question.randomizedPairs"
                v-model="form[question.id][choice.id]"
              ></hilo-select>
            </div>
          </div>
        </div>
      </div>
      <div class="submitContainer" @click="onSubmit">
        <div class="submitWrapper">
          <b class="text">Submit</b>
        </div>
      </div>
    </div>
    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import { useLoginStore } from "@/stores/loginStore";
import HiloSelect from "../../../../components/HiloComponents/HiloSelect.vue";
import ToastNotifier from "@/components/ToastNotifier.vue";
import AssignmentsAPIService from "../../../../servicehandlers/AssignmentsAPIService.js";
const assignmentService = new AssignmentsAPIService();

export default {
  components: {
    HiloSelect,
    ToastNotifier,
  },
  data() {
    return {
      gradeView: false,
      studentId: null,
      assignmentId: null,
      assignment: {},
      aiResponses: [],
      historyReportOpen: false,
      form: {},
      percentage: 0,
    };
  },
  async mounted() {
    this.assignmentId = this.$route.query.assignmentId;
    this.assignment = await assignmentService.getAssignmentById(
      this.assignmentId,
      this.$router,
    );
    for (let question of this.assignment.questions) {
      if (
        question.questionType.name === "Multiple Choice" ||
        question.questionType.name === "Select All That Apply"
      ) {
        question.questionChoices.sort(() => Math.random() - 0.5);
      } else if (question.questionType.name === "Matching") {
        this.form[question.id] = {};
        question.randomizedPairs = [];
        for (let choice of question.questionChoices) {
          let temp = {
            id: choice.id,
            name: choice.matchingString,
          };
          question.randomizedPairs.push(temp);
        }
        question.randomizedPairs.sort(() => Math.random() - 0.5);
      }
    }
  },
  computed: {
    currentUser() {
      return useLoginStore().getUser;
    },
  },
  methods: {
    handleSelect(event, questionId, choiceValue) {
      if (!this.form[questionId]) this.form[questionId] = [];

      if (event.target.checked) {
        this.form[questionId].push(choiceValue);
      } else {
        this.form[questionId] = this.form[questionId].filter((item) => {
          return item !== choiceValue;
        });
      }

      this.$forceUpdate();
    },
    getQuestionType(obj, qType, qIndex) {
      return obj.questionType.name === qType;
    },
    toggleAdminAssignmentHistoryRep() {
      this.historyReportOpen = !this.historyReportOpen;
    },
    navigateBack() {
      this.$router.go(-1);
    },
    async onSubmit() {
      try {
        let assignmentTotal = 0;
        let studentTotal = 0;
        let studentAnswers = [];

        let validations = [];

        for (let question of this.assignment.questions) {
          switch (question.questionType.name) {
            case "Multiple Choice":
              if (this.form[question.id]) {
                let max = 0;
                for (let choice of question.questionChoices) {
                  if (choice.pointValue > max) {
                    max = parseFloat(choice.pointValue);
                  }
                  if (choice.id === this.form[question.id]) {
                    studentTotal += parseFloat(choice.pointValue);
                    let temp = {
                      questionId: question.id,
                      studentAnswerChoiceId: choice.id,
                    };
                    studentAnswers.push(temp);
                  }
                }
                assignmentTotal += max;
              } else {
                let index = this.assignment.questions.indexOf(question) + 1;
                validations.push(`Question ${index} is missing an answer`);
              }
              break;
            case "Select All That Apply":
              if (this.form[question.id]) {
                let selectPossible = 0;
                for (let choice of question.questionChoices) {
                  if (choice.pointValue > 0) {
                    selectPossible += parseFloat(choice.pointValue);
                  }
                  if (this.form[question.id].includes(choice.id)) {
                    studentTotal += parseFloat(choice.pointValue);
                    let temp = {
                      questionId: question.id,
                      studentAnswerChoiceId: choice.id,
                    };
                    studentAnswers.push(temp);
                  }
                }

                assignmentTotal += selectPossible;
              } else {
                let index = this.assignment.questions.indexOf(question) + 1;
                validations.push(`Question ${index} is missing an answer`);
              }
              break;
            case "Short Answer":
              if (this.form[question.id]) {
                // for implementation: AI should check if the answer matches the correct answer
              } else {
                let index = this.assignment.questions.indexOf(question) + 1;
                validations.push(`Question ${index} is missing an answer`);
              }
              break;
            case "Matching":
              if (
                Object.keys(this.form[question.id]).length ===
                question.questionChoices.length
              ) {
                let matchingPossible = 0;
                for (let choice of question.questionChoices) {
                  if (choice.pointValue > 0) {
                    matchingPossible += parseFloat(choice.pointValue);
                  }
                  if (this.form[question.id][choice.id] === choice.id) {
                    studentTotal += parseFloat(choice.pointValue);
                  }
                  let temp = {
                    questionId: question.id,
                    studentAnswerChoiceId: choice.id,
                    studentMatchingChoiceId: this.form[question.id][choice.id],
                  };
                  studentAnswers.push(temp);
                }

                assignmentTotal += matchingPossible;
              } else {
                let index = this.assignment.questions.indexOf(question) + 1;
                validations.push(`Question ${index} is missing an answer`);
              }
              break;
            default:
              break;
          }
        }

        if (validations.length) {
          let validationString = "";
          for (let string of validations) {
            validationString += string;
            if (validations.indexOf(string) !== validations.length - 1) {
              validationString += ", ";
            }
          }
          this.$refs.toast.showError(validationString);
          return;
        }

        this.percentage = (studentTotal / assignmentTotal) * 100;

        if (!this.assignment.graded) {
          this.percentage = 100;
        }

        const payload = {
          userId: this.currentUser.id,
          assignmentId: this.assignment.id,
          gradePercentage: parseFloat(this.percentage),
          studentAnswers,
        };

        const response = await assignmentService.createStudentAssignment(
          payload,
          this.$router,
        );

        this.$router.push({
          name: "Graded Assignment",
          query: {
            assignmentId: this.assignment.id,
            fromTake: true,
          },
        });
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.textArea {
  border: none;
  width: 100%;
  resize: none;
  outline: none;
}

.text {
  position: relative;
}

.pageTitle {
  position: relative;
  color: #404040;
}

.breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.headerContent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  z-index: 0;
  position: relative;
}

.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}

.header {
  width: 100%;
  margin: 0 !important;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  position: relative;
  gap: 20px;
  z-index: 6;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}

.quizObjective {
  align-self: stretch;
  position: relative;
  font-size: 18px;
}

.quizOverview {
  width: 900px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 75px 150px;
  box-sizing: border-box;
  gap: 30px;
}

.quizOverviewContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 50px;
  z-index: 5;
  font-size: 45px;
}

.questionNumber {
  align-self: stretch;
  position: relative;
  font-size: 22px;
}

.question {
  align-self: stretch;
  position: relative;
}

.answerContainer {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  padding: 10px 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 100%;
  /* box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; */
}
.answerContainer input {
  position: absolute;
  right: 20px;
  width: 12px;
}
.answerContainer label {
  margin: 0;
  font-size: 16px;
}
.frameParent2 {
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.questionContainer {
  width: 900px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  height: auto;
  overflow-y: visible;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 75px 150px;
  box-sizing: border-box;
  gap: 30px;
  z-index: 4;
}

.quizTitle {
  align-self: stretch;
  position: relative;
}

.answer {
  flex: 1;
  position: relative;
}

.answerWrapper {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  /* box-sizing: border-box;
  height: 150px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start; */
  padding: 20px;
  width: 100%;
}

.column1Matching {
  align-self: stretch;
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
}

.column2Matching {
  flex: 1;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 103px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.matchingChoiceContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.matchingContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.submitWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.submitContainer {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
  z-index: 1;
  color: #fff;
}

.container {
  margin: 0;
  height: 100%;
  flex: 1;
  max-width: 100% !important;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.assignment {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
}
</style>
